/**
 * Created by xing.lin on 2019/6/11.
 */
import error from './error'
import info from './info'
import formValidate from './formValidate'
import confirmBox from './confirmBox'

export const global = {
  error,
  info,
  confirmBox
}

export const local = {
  formValidate
}



// WEBPACK FOOTER //
// ./src/mixin/index.js